import { HttpErrorResponse } from '@angular/common/http';

import { ReferralOfferAssignment } from '@recruitee/http-types';
import { createEntityCollectionStore, pipeState } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ReferralOfferAssignment>()('ReferralsOfferAssignmentCollection', {
    idSelector: e => e.offer.slug,
    customActions: adapter => ({
      fetchOne: (state, payload: { id: string }) =>
        adapter.markAsPending(state, { scope: null, entities: [payload.id] }),
      fetchOneSuccess: (state, payload: { data: ReferralOfferAssignment }) =>
        pipeState(adapter.upsertOne(state, payload.data), next =>
          adapter.markAsLoaded(next, { scope: null, entities: [payload.data.offer.slug] }),
        ),
      toggle: (state, payload: { offerId: string; enabled: boolean }) =>
        pipeState(adapter.markAsPending(state, { scope: null, entities: [payload.offerId] })),
      toggleSuccess: (state, payload: { data: Partial<ReferralOfferAssignment> }) =>
        pipeState(adapter.updateOne(state, payload.data), next =>
          adapter.markAsLoaded(next, { scope: null, entities: [payload.data.offer?.slug!] }),
        ),
      toggleFailed: (state, payload: { offerId: string; error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error, { scope: null, entities: [payload.offerId] }),
      assignReward: (state, payload: { offerId: string; referralRewardId: number | null }) =>
        pipeState(adapter.markAsPending(state, { scope: null, entities: [payload.offerId] })),
      assignRewardSuccess: (state, payload: { data: Partial<ReferralOfferAssignment> }) =>
        pipeState(adapter.updateOne(state, payload.data), next =>
          adapter.markAsLoaded(next, { scope: null, entities: [payload!.data.offer?.slug!] }),
        ),
      assignRewardFailed: (state, payload: { offerId: string; error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error, { scope: null, entities: [payload.offerId] }),
      assignTemplate: (
        state,
        payload: { offerId: number; slug: string; templateId: number | null },
      ) => pipeState(adapter.markAsPending(state, { scope: null, entities: [payload.slug] })),
      assignTemplateSuccess: (state, payload: { data: Partial<ReferralOfferAssignment> }) => {
        let entity = payload.data;
        entity = { ...entity };
        entity.referralTemplate = entity.referralTemplate ?? null;
        return pipeState(adapter.updateOne(state, entity), next =>
          adapter.markAsLoaded(next, { scope: null, entities: [payload!.data.offer?.slug!] }),
        );
      },
      assignTemplateFailed: (state, payload: { slug: string; error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error, { scope: null, entities: [payload.slug] }),
    }),
  });

export {
  actions as ReferralsOfferAssignmentActions,
  reducer as ReferralsOfferAssignmentReducer,
  selectors as ReferralsOfferAssignmentSelectors,
  namespace as ReferralsOfferAssignmentNamespace,
};
